export const FETCH_ALL_CATEGORIES = "FETCH_ALL_CATEGORIES";
export const FETCH_ACTIVE_CATEGORIES = "FETCH_ACTIVE_CATEGORIES";
export const RESET_ALL_CATEGORIES = "RESET_ALL_CATEGORIES";
export const SHOW_MODAL = "SHOW_MODAL";
export const IS_EDITED = "IS_EDITED";
export const SAVE_EDITS = "SAVE_EDITS";
export const ADD_CAT = "ADD_CAT";
export const SHOW_LOADER = "SHOW_LOADER";